import firebase from "firebase/app";
import "firebase/analytics";

export class Analytics {
    public static downloadWallpaper(code: string) {
        firebase.analytics().logEvent(
            "download-quilt-wallpaper",
            {
                "code": code
            });
    }

    public static shareQuilt(code: string) {
        firebase.analytics().logEvent(
            "share-quilt",
            {
                "code": code
            });
    }

    public static generateQuilt() {
        firebase.analytics().logEvent("generate-quilt");
    }

    public static showQuiltInfo(code: string) {
        firebase.analytics().logEvent(
            "show-quilt-info",
            {
                "code": code
            });
    }

    public static favoriteQuilt(code: string) {
        firebase.analytics().logEvent(
            "favorite-quilt",
            {
                "code": code
            }
        );
    }
}